// eslint-disable-next-line no-restricted-imports
import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  bodyContainer: {
    display: 'flex',
    padding: theme.spacing(2, 4),
    flexDirection: 'column',
    color: theme.palette.text.secondary,
  },
  innerContainer: {
    display: 'inline-flex',
    flexWrap: 'wrap',
  },
  bodyText: {
    paddingBottom: theme.spacing(3.5),
  },
}));
